var _path, _g, _circle, _g2, _g3, _path2, _path3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaymanIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.384-114.616 256-256 256s-256-114.616-256-256c0 .061 256-255.972 256-256 141.384 0 256 114.616 256 256z",
    fill: "#0052b4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-.016 0-.028 0-.043 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.315 256h.685c0-.23 0-.454 0-.685-.228.229-.456.457-.685.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 133.565c0-45.045 0-74.56 0-133.565h-.043c-141.366.024-255.957 114.629-255.957 256h133.565v-75.211l75.211 75.211h46.54c.228-.228.456-.456.685-.685 0-17.247 0-32.636 0-46.537l-75.213-75.213z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 367.304,
    cy: 144.696,
    fill: "#6da544",
    r: 44.522
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.515 33.391c-40.039 22.799-73.326 56.085-96.124 96.124v126.485h66.783v-155.824-.002h155.826c0-21.063 0-41.129 0-66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 224.519-90.955-90.953h-31.48v.002l122.433 122.432h.002s0-21.707 0-31.481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.391 133.565h155.826v66.783h-155.826z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m445.217 256v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.391 256v-.001z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m289.391 300.522v44.522h23.424c14.045 13.764 33.27 22.261 54.489 22.261s40.444-8.497 54.489-22.261h1.163 22.261v-44.522z",
    fill: "#ffda44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m289.391 189.217v66.783c0 59.639 77.913 77.913 77.913 77.913s77.913-18.274 77.913-77.913v-66.783z",
    fill: "#338af3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#f3f3f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m367.3 224.889c-19.477 0-19.477 17.809-38.954 17.809s-19.477-17.809-38.954-17.809v31.165c19.477 0 19.477 17.809 38.954 17.809s19.477-17.809 38.954-17.809c19.479 0 19.479 17.809 38.959 17.809s19.479-17.809 38.959-17.809v-31.165c-19.479 0-19.479 17.809-38.959 17.809s-19.48-17.809-38.959-17.809z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.3 162.504c-19.477 0-19.477 17.809-38.954 17.809s-19.477-17.809-38.954-17.809v31.165c19.477 0 19.477 17.809 38.954 17.809s19.477-17.809 38.954-17.809c19.479 0 19.479 17.809 38.959 17.809s19.479-17.809 38.959-17.809v-31.165c-19.479 0-19.479 17.809-38.959 17.809s-19.48-17.809-38.959-17.809z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaymanIslands);
export default __webpack_public_path__ + "static/media/cayman-islands.4b0af3167f938c10f3e4ea7f1b90ea6c.svg";
export { ForwardRef as ReactComponent };